import React, { Component } from "react"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { Link } from "react-router-dom"

class ReportCount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      socials: [
        {
          title: "Branch Count",
          bgColor: "bg-primary",
          iconClass: "mdi-account-box-multiple",
          description: "125",
        },
        {
          title: "User Count",
          bgColor: "bg-primary",
          iconClass: "mdi-account-box-multiple",
          description: "125",
        },
        {
          title: "Today's Reports",
          bgColor: "bg-info",
          iconClass: "mdi-calendar-today",
          description: "112",
        },
        
      ],
    }
  }

 

  render() {
    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <CardTitle className="mb-4 h4">AI Reports</CardTitle>
            <div className="text-center">

              <p className="font-16 text-muted mb-2"/>
              <h5>
                <Link to="#" className="text-dark">
                  Total Reports -{" "}
                  <span className="text-muted font-16">125</span>{" "}
                </Link>
              </h5>
              <p className="text-muted">
                Reports created in Kattam Intelligence.
              </p>
             </div>
            <Row className="mt-3">
              {this.state.socials.map((social, key) => (
                <Col xs="6" key={"_li_" + key}>
                  <div className="social-source text-center mt-3">
                    <div className="avatar-xs mx-auto mb-3">
                      <span
                        className={
                          "avatar-title rounded-circle " +
                          social.bgColor +
                          " font-size-16"
                        }
                      >
                        <i
  className={"mdi " + social.iconClass + " text-white"}
  />
                      </span>
                    </div>
                    <h5 className="font-size-15">{social.title}</h5>
                    <p className="text-muted mb-0">
                      {social.description} 
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

export default ReportCount
